import React from 'react';
import PropTypes from 'prop-types';

import useGroupLockActions from '../../../hooks/useGroupLockActions';
import { useStore } from '../../../hooks';
import {
  FLOATING_TOOLBAR_ICON_SIZE,
  StyledFloatingToolbarButton,
  StyledFloatingToolbarButtonGroup,
} from '../FloatingToolbar.styled';
import buildGroupLockContextualButtons from './buildGroupLockContextualButtons';

const FloatingGroupLockActions = ({ className = '' }) => {
  const { t } = useStore();
  const api = useGroupLockActions();

  if (!api.hasSelection) {
    return null;
  }

  const buttons = buildGroupLockContextualButtons(api).map((button) => ({
    ...button,
    title: t(button.titleKey),
  }));

  if (buttons.length === 0) {
    return null;
  }

  return (
    <StyledFloatingToolbarButtonGroup
      className={`respark_floating-group-lock-actions${className ? ` ${className}` : ''}`}
      role="group"
      aria-label={t('groupLockTitle')}
    >
      {buttons.map(({ id, title, Icon, onClick }) => (
        <StyledFloatingToolbarButton
          key={id}
          type="button"
          className={`respark_floating-toolbar-btn respark_floating-toolbar-btn--${id}`}
          title={title}
          aria-label={title}
          onClick={onClick}
        >
          <Icon size={FLOATING_TOOLBAR_ICON_SIZE} />
        </StyledFloatingToolbarButton>
      ))}
    </StyledFloatingToolbarButtonGroup>
  );
};

FloatingGroupLockActions.propTypes = {
  className: PropTypes.string,
};

export default FloatingGroupLockActions;
